module.exports = __webpack_public_path__ + "static/media/default.d777c608.jpg";